module.exports = __webpack_public_path__ + "img/list-pattern1.9c22494.svg";